export const DOC_WIDTH = 600

export const MILES_TO_KILOMETRES = 1.60934
export const KILOMETRES_TO_MILES = 0.621371
export const FEET_TO_METRES = 0.3048
export const METRES_TO_FEET = 3.28084
export const LBS_TO_KG = 0.453592
export const KG_TO_LBS = 2.20462

export const UNITS = {
  METRIC: {
    id: 'METRIC',
    massUnits: 'kg',
    distanceUnits: 'm',
    speedUnits: 'km/h',
  },
  US: {
    id: 'US',
    massUnits: 'lbs',
    distanceUnits: 'ft',
    speedUnits: 'mph',
  },
}

export const DEFAULT_PROJECT_CENTER = [144.9631, -37.8136]
